import { Form } from 'antd';
import { useCallback, useState } from 'react';
import { useNotificationMessages } from 'hooks/useNotificationMessages';
import { useItemSelectorListQuery, useUpdateSupplierOfferItemMutation } from 'api';
import { useParams } from 'react-router-dom';

export const useAlternativeModal = ({
  originalItemId,
  onCancel,
}: {
  originalItemId?: string;
  onCancel: () => void;
}) => {
  const [brandId, setBrandId] = useState<string | undefined>(undefined);
  const [item, setItem] = useState<any | undefined>(undefined);
  const { supplierOfferId } = useParams() as { supplierOfferId: string };
  const [form] = Form.useForm();
  const { handleSuccess, handleError } = useNotificationMessages();
  const [updateSupplierOfferItem, { isLoading }] = useUpdateSupplierOfferItemMutation();

  const { data = [] } = useItemSelectorListQuery(brandId, { skip: !brandId });
  const onBrandChange = useCallback(
    (value: string) => {
      setBrandId(value);
      form.setFieldsValue({ sku: undefined });
    },
    [form]
  );
  const onItemChange = useCallback((option: any) => {
    setItem(option);
  }, []);

  const onModalCancel = useCallback(() => {
    onCancel();
    form.resetFields();
  }, [form, onCancel]);

  const onFinish = useCallback(async () => {
    try {
      const { data, error } = await updateSupplierOfferItem({
        data: [
          {
            id: originalItemId,
            item: {
              itemActionType: 'ALTERNATIVE',
            },
            alternativeItems: [
              {
                brandId,
                itemNumber: item?.id,
                item: {
                  itemNumber: item?.id,
                  sku: item.sku,
                  uuid: item.uuid || null,
                },
              },
            ],
          },
        ],
        supplierOfferId,
      });
      if (data?.success) {
        handleSuccess('Alternative was successfully added.');
        onModalCancel();
      } else {
        handleError(error);
      }
    } catch (err) {
      handleError(err);
    }
  }, [
    handleError,
    handleSuccess,
    originalItemId,
    updateSupplierOfferItem,
    brandId,
    item?.id,
    item?.sku,
    item?.uuid,
    supplierOfferId,
    onModalCancel,
  ]);
  return { form, onFinish, isLoading, onBrandChange, onItemChange, data, onCancel, onModalCancel };
};
